import React, { useContext } from "react";
import { UserContext } from "components/UserProvider";

export default function useUser() {
  return useContext(UserContext);
};
